import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { foreverValue, IOS_HINT_STORAGE_KEY, snoozeUntil } from '../../utils/ios-push-hint';

/**
 * Banner pedagogico para iPhone/iPad: explica como instalar la PWA (requisito de iOS 16.4+ para
 * recibir Web Push) en vez de pedir un permiso que Safari no puede conceder.
 */
@Component({
  selector: 'app-ios-install-banner',
  standalone: true,
  imports: [CommonModule],
  template: `
    <aside
      class="fixed left-3 right-3 bottom-20 z-[9000] mx-auto max-w-md rounded-2xl border border-slate-700/60 bg-slate-900/90 backdrop-blur-md p-4 shadow-2xl text-white"
      role="note"
      aria-label="Instala SmartBreak en tu iPhone">
      <div class="flex items-start gap-3">
        <div class="text-2xl leading-none">📲</div>
        <div class="flex-1 min-w-0">
          <h3 class="text-sm font-bold leading-tight">Recibe tus recordatorios en el iPhone</h3>
          <p class="text-xs text-slate-300 mt-1 leading-relaxed">
            Apple solo permite las notificaciones si agregas SmartBreak a tu pantalla de inicio:
          </p>
          <ol class="mt-2 space-y-1 text-xs text-slate-200 list-decimal pl-4">
            <li>Toca el botón <strong>Compartir</strong> <span aria-hidden="true">⬆️</span> de Safari.</li>
            <li>Elige <strong>Agregar a pantalla de inicio</strong>.</li>
            <li>Abre SmartBreak desde el nuevo icono y activa los recordatorios.</li>
          </ol>
          <div class="mt-3 flex flex-wrap gap-2">
            <button
              type="button"
              (click)="later()"
              class="rounded-xl bg-gradient-to-r from-emerald-500 to-[#00F0FF] px-3.5 py-2 text-xs font-bold text-slate-900">
              Entendido
            </button>
            <button
              type="button"
              (click)="never()"
              class="rounded-xl border border-slate-600 px-3.5 py-2 text-xs font-semibold text-slate-300 hover:bg-slate-800">
              No volver a mostrar
            </button>
          </div>
        </div>
      </div>
    </aside>
  `
})
export class IosInstallBannerComponent {
  @Output() dismissed = new EventEmitter<void>();

  later(): void {
    this.save(snoozeUntil());
  }

  never(): void {
    this.save(foreverValue());
  }

  private save(value: string): void {
    try {
      localStorage.setItem(IOS_HINT_STORAGE_KEY, value);
    } catch {
      // sin localStorage el aviso volvera en la siguiente visita
    }
    this.dismissed.emit();
  }
}
